import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';
import { RulesetResult } from '../../pages/dashboard/loan_detail/flows/NewWelcomeFlow/business/rules';
import OfftakerPPAorLeaseAgreementRuleset from '../../pages/dashboard/loan_detail/flows/NewWelcomeFlow/business/ruleset/OfftakerPPAorLeaseAgreementRuleset';
import MultipleFilesValidationSchema from '../MultipleFilesValidationSchema';

const { offtakerPPAorLeaseAgreement } =
  loanFormModel.formField.solarSystemDocuments;

export class OfftakerPPAorLeaseAgreementValidation implements ValidationSchema {
  public name = offtakerPPAorLeaseAgreement.name;
  public label = '';

  public type = 'array';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public ruleset = OfftakerPPAorLeaseAgreementRuleset;

  public when(schema: any, ...args: any[]) {
    const result: RulesetResult = args.pop();
    const required = !!(result & RulesetResult.REQUIRED);

    return MultipleFilesValidationSchema(
      offtakerPPAorLeaseAgreement.name,
      required
    );
  }
}
export default new Validation(new OfftakerPPAorLeaseAgreementValidation());
